export enum KeyCode {
    Right = 39,
    Left = 37,
    Escape = 27
}